import React, { Component } from "react";
import PropTypes from "prop-types";
import LoanAmount from "./LoanAmount";
import Name from "./Name";
import RecipientRelationship from "./RecipientRelationship";

const APPLICANT = "applicant";

class PI1FormSecAmount extends Component {
  constructor(props) {
    super(props);
  }

  static defaultProps = {
    secName: "sectionAmount",
    secTitle: "Loan Amount and Patient Info",
    sectionStatus: "",
    MAStateSelected: false,
    clientInfo: {},
    clientProds: {},
    userType: APPLICANT,
  };

  handleEventCallback = (ev, data) => {
    const { name } = ev.target,
      { toggleApplicantName, onSectionCallback, secName, sectionMetadata } =
        this.props;

    let fieldName = name;

    if (ev.type === "change" && name === "relationship") {
      toggleApplicantName(ev);
    }

    if (name === "amount") {
      fieldName = "loanAmount";
    } else if (name === "firstname") {
      fieldName = "recipientFN";
    } else if (name === "lastname") {
      fieldName = "recipientLN";
    }

    sectionMetadata.fields[fieldName].value = data.value;
    sectionMetadata.fields[fieldName].status = data.status;
    sectionMetadata.fields[fieldName].isValid = data.isValid;

    if (onSectionCallback && typeof onSectionCallback === "function") {
      onSectionCallback(secName, fieldName, sectionMetadata.fields[fieldName]);
    }
  };

  render() {
    const {
      secTitle,
      MAStateSelected,
      MA_minAmt,
      minLoanAmt,
      maxLoanAmt,
      clientInfo,
      clientProds,
      userType,
      sectionMetadata,
    } = this.props;

    return (
      <fieldset className="pf-registration section-1 loan-amount-recipient">
        <legend className="show-for-sr">{secTitle}</legend>
        <LoanAmount
          onEventCallback={this.handleEventCallback}
          fieldMetadata={sectionMetadata.fields.loanAmount}
          minLoanAmt={minLoanAmt}
          maxLoanAmt={maxLoanAmt}
          MAStateSelected={MAStateSelected}
          MA_minAmt={MA_minAmt}
          userType={userType}
          clientInfo={clientInfo}
          clientProds={clientProds}
        />
        <Name
          nameType="recipient"
          nameGroupLabel="Patient name"
          onEventCallback={this.handleEventCallback}
          firstNameMetadata={sectionMetadata.fields.recipientFN}
          lastNameMetadata={sectionMetadata.fields.recipientLN}
        />
        <RecipientRelationship
          onEventCallback={this.handleEventCallback}
          fieldMetadata={sectionMetadata.fields.relationship}
        />
      </fieldset>
    );
  }
}

PI1FormSecAmount.propTypes = {
  userType: PropTypes.string.isRequired,
  secTitle: PropTypes.string.isRequired,
  toggleApplicantName: PropTypes.func.isRequired,
  sectionMetadata: PropTypes.object.isRequired,
  clientInfo: PropTypes.object.isRequired,
  clientProds: PropTypes.object.isRequired,
  onSectionCallback: PropTypes.func.isRequired,
  sectionStatus: PropTypes.string.isRequired,
  secName: PropTypes.string,
  minLoanAmt: PropTypes.number,
  maxLoanAmt: PropTypes.number,
  MAStateSelected: PropTypes.bool,
  MA_minAmt: PropTypes.number.isRequired,
  defaultValues: PropTypes.object,
};

export default PI1FormSecAmount;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');